export default __webpack_public_path__ + "static/media/business_show_2_en.8b912706.png";